module.exports = __webpack_public_path__ + "static/media/splash-mage.d01d7c72.png";